import { useDisclosure } from '@chakra-ui/react';
import { Trans } from '@lingui/macro';

import PARTNER_TAG from '../../../../enums/EnumPartnerTag';
import ButtonSubmit from '../../../generic/button/ButtonSubmit';
import PartnerFfvPopup from '../../../partner/PartnerFfvPopup';
import SelectedOptionDetail from './SelectedOptionDetail';

const OptionCustomRightSide = ({ selectedId, partnerTag, relatedSessionGroupId, participantDetails }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <SelectedOptionDetail selectedId={selectedId} partnerTag={partnerTag} />

      {partnerTag === PARTNER_TAG.FFV && (
        <>
          <ButtonSubmit onClick={() => onOpen()} type="button">
            <Trans>Check license</Trans>
          </ButtonSubmit>
          <PartnerFfvPopup isOpen={isOpen} onClose={onClose} relatedSessionGroupId={relatedSessionGroupId} participantDetails={participantDetails} />
        </>
      )}
    </>
  );
};

export default OptionCustomRightSide;
